import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { getCitabilityParagraphs } from "../seo/citabilityCopy";

interface CitabilitySectionProps {
  routeKey: string;
}

const CitabilitySection: React.FC<CitabilitySectionProps> = ({ routeKey }) => {
  const paragraphs = getCitabilityParagraphs(routeKey);

  if (!paragraphs.length) {
    return null;
  }

  return (
    <Box
      component="section"
      aria-label="CosyLab service overview"
      sx={{
        py: { xs: 4, md: 6 },
        px: { xs: 2, md: 0 },
        borderTop: "1px solid rgba(139, 195, 74, 0.15)",
        backgroundColor: "rgba(250, 251, 248, 0.6)",
      }}
    >
      <Container maxWidth="md">
        {paragraphs.map((paragraph: string, index: number) => (
          <Typography
            key={index}
            component="p"
            variant="body1"
            sx={{
              mb: index < paragraphs.length - 1 ? 2.5 : 0,
              lineHeight: 1.85,
              color: "text.secondary",
              fontSize: { xs: "0.95rem", md: "1rem" },
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Container>
    </Box>
  );
};

export default CitabilitySection;
